// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3Fl1f","topBottomGutter":"Layout_topBottomGutter__1AL-x"};